import { z } from "zod";
import { DocumentTaxonomy } from "@common/documentCategories";

export const documentCategorySchema = z.object({
    id: z.string(),
    label: z.string(),
    description: z.string().nullable(),
    workspaceId: z.string().nullable(),
    documentTaxonomy: z.nativeEnum(DocumentTaxonomy),
    parentCategoryId: z.string().nullable(),
});

export type DocumentCategorySchema = z.infer<typeof documentCategorySchema>;

export const createDocumentCategoryBodySchema = z.object({
    label: z.string().min(1).max(255),
    description: z.string().max(2000).optional().nullable(),
    parentCategoryId: z.string().uuid(),
});

export const updateDocumentCategoryBodySchema = z.object({
    label: z.string().min(1).max(255),
    description: z.string().max(2000).optional().nullable(),
});
